import {Index as Index} from '/router/routes/index.js';
import {Fonts as Fonts} from '/router/routes/index/fonts.js';
import {Color as Color} from '/router/routes/index/color.js';
import {Shadow as Shadow} from '/router/routes/index/shadow.js';
import {Utility_class as Utility_class} from '/router/routes/index/utility_class.js';
import {Column_list as Column_list} from '/router/routes/index/column_list.js';
import {Criteria_editor as Criteria_editor} from '/router/routes/index/criteria_editor.js';
import {Autocomplete as Autocomplete} from '/router/routes/index/autocomplete.js';
import {Checkbox as Checkbox} from '/router/routes/index/checkbox.js';
import {Search as Search} from '/router/routes/index/search.js';
import {Stepper as Stepper} from '/router/routes/index/stepper.js';
import {Tabs as Tabs} from '/router/routes/index/tabs.js';
import {Toaster as Toaster} from '/router/routes/index/toaster.js';
import {Tooltip as Tooltip} from '/router/routes/index/tooltip.js';
import {Tree as Tree} from '/router/routes/index/tree.js';
import {Accordion as Accordion} from '/router/routes/index/accordion.js';
import {Alert as Alert} from '/router/routes/index/alert.js';
import {Attention as Attention} from '/router/routes/index/attention.js';
import {Body as Body} from '/router/routes/index/body.js';
import {Button as Button} from '/router/routes/index/button.js';
import {Card as Card} from '/router/routes/index/card.js';
import {Datepicker as Datepicker} from '/router/routes/index/datepicker.js';
import {Dropdown as Dropdown} from '/router/routes/index/dropdown.js';
import {Empty_template as Empty_template} from '/router/routes/index/empty_template.js';
import {Fileupload as Fileupload} from '/router/routes/index/fileupload.js';
import {Input as Input} from '/router/routes/index/input.js';
import {Key_value_pair as Key_value_pair} from '/router/routes/index/key_value_pair.js';
import {Label as Label} from '/router/routes/index/label.js';
import {Label_value_pair as Label_value_pair} from '/router/routes/index/label_value_pair.js';
import {Link as Link} from '/router/routes/index/link.js';
import {Modal as Modal} from '/router/routes/index/modal.js';
import {Pagination as Pagination} from '/router/routes/index/pagination.js';
import {Radio as Radio} from '/router/routes/index/radio.js';
import {Sub_header as Sub_header} from '/router/routes/index/sub_header.js';
import {Table as Table} from '/router/routes/index/table.js';
import {Hovercard as Hovercard} from '/router/routes/index/hovercard.js';
import {Link_box as Link_box} from '/router/routes/index/link_box.js';
import {Avatar as Avatar} from '/router/routes/index/avatar.js';
import {Loader as Loader} from '/router/routes/index/loader.js';
import {Test as Test} from '/router/routes/index/test.js';
import {Tour as Tour} from '/router/routes/index/tour.js';
import {Profile_menu as Profile_menu} from '/router/routes/index/profile_menu.js';
import {Code_block as Code_block} from '/router/routes/index/code_block.js';
import {DatePicker as DatePicker} from '/router/routes/index/date-picker.js';
import {TimePicker as TimePicker} from '/router/routes/index/time-picker.js';
import {Daterangepicker as Daterangepicker} from '/router/routes/index/daterangepicker.js';
import {Timerangepicker as Timerangepicker} from '/router/routes/index/timerangepicker.js';
import {SubHeader as SubHeader} from '/router/routes/index/sub-header.js';
import {Popover as Popover} from '/router/routes/index/popover.js';
import {Sidemenu as Sidemenu} from '/router/routes/index/sidemenu.js';
import {FullpageModal as FullpageModal} from '/router/routes/index/fullpage-modal.js';
import {TimeLine as TimeLine} from '/router/routes/index/time-line.js';
import {Breadcrumb as Breadcrumb} from '/router/routes/index/breadcrumb.js';
import {Editor as Editor} from '/router/routes/index/editor.js';
import {Icons as Icons} from '/router/routes/index/icons.js';
import {Dateselect as Dateselect} from '/router/routes/index/dateselect.js';
import {Timezone as Timezone} from '/router/routes/index/timezone.js';
import {Doublefield as Doublefield} from '/router/routes/index/doublefield.js';
import {ModalTest as ModalTest} from '/router/routes/index/modal-test.js';
import {LayoutHeader as LayoutHeader} from '/router/routes/index/layout-header.js';

import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { RouterMap } from "../../node_modules/@slyte/router/index.js";

class ZcatComponentsMap extends RouterMap {
  map() {
    this.route('index', {
      path: '/',
      handler: Index
    }, () => {
      // base
      this.route('fonts', {
        path: '/base/typography',
        handler: Fonts
      });
      this.route('color', {
        path: '/base/colors',
        handler: Color
      });
      this.route('shadow', {
        path: '/base/shadow',
        handler: Shadow
      });
      this.route('utility_class', {
        path: '/base/utility_class',
        handler: Utility_class
      });
      // crux
      this.route('column_list', {
        path: '/crux/column_list',
        handler: Column_list
      });
      this.route('criteria_editor', {
        path: '/crux/criteria_editor',
        handler: Criteria_editor
      });
      // lyte
      this.route('autocomplete', {
        path: '/lyte/autocomplete',
        handler: Autocomplete
      });
      this.route('checkbox', {
        path: '/lyte/checkbox',
        handler: Checkbox
      });
      this.route("search", {
        path: '/lyte/search',
        handler: Search
      });
      this.route('stepper', {
        path: '/lyte/stepper',
        handler: Stepper
      });
      this.route('tabs', {
        path: '/lyte/tabs',
        handler: Tabs
      });
      this.route('toaster', {
        path: '/lyte/toaster',
        handler: Toaster
      });
      this.route('tooltip', {
        path: '/lyte/tooltip',
        handler: Tooltip
      });
      this.route('tree', {
        path: '/lyte/tree',
        handler: Tree
      });
      // zcat
      this.route('accordion', {
        path: '/zcat/accordion',
        handler: Accordion
      });
      this.route("alert", {
        path: '/zcat/alert',
        handler: Alert
      });
      this.route("attention", {
        path: "/zcat/attention",
        handler: Attention
      });
      this.route('body', {
        path: '/zcat/body',
        handler: Body
      });
      this.route('button', {
        path: '/zcat/button',
        handler: Button
      });
      this.route("card", {
        path: "/zcat/card",
        handler: Card
      });
      this.route('datepicker', {
        path: '/zcat/datepicker',
        handler: Datepicker
      });
      this.route('dropdown', {
        path: '/zcat/dropdown',
        handler: Dropdown
      });
      this.route('empty_template', {
        path: '/zcat/empty-template',
        handler: Empty_template
      });
      this.route('fileupload', {
        path: '/zcat/file_upload',
        handler: Fileupload
      });
      this.route('input', {
        path: '/zcat/textbox',
        handler: Input
      });
      this.route('key_value_pair', {
        path: '/zcat/key-value-pair',
        handler: Key_value_pair
      });
      this.route('label', {
        path: '/zcat/label',
        handler: Label
      });
      this.route('label_value_pair', {
        path: '/zcat/label-value-pair',
        handler: Label_value_pair
      });
      this.route('link', {
        path: '/zcat/link-button',
        handler: Link
      });
      this.route('modal', {
        path: '/zcat/modal',
        handler: Modal
      });
      this.route("pagination", {
        path: "/zcat/pagination",
        handler: Pagination
      });
      this.route('radio', {
        path: '/zcat/radio_button',
        handler: Radio
      });
      this.route('sub_header', {
        path: '/zcat/sub-header',
        handler: Sub_header
      });
      this.route('table', {
        path: '/zcat/table',
        handler: Table
      });
      this.route("hovercard", {
        path: '/zcat/hovercard',
        handler: Hovercard
      });
      this.route("link_box", {
        path: "/zcat/link_box",
        handler: Link_box
      });
      this.route("avatar", {
        path: "/zcat/avatar",
        handler: Avatar
      });
      this.route("loader", {
        path: "/zcat/loader",
        handler: Loader
      });
      this.route("test", {
        path: '/zcat/test',
        handler: Test
      });
      this.route("tour", {
        path: "/zcat/tour",
        handler: Tour
      });
      this.route("profile_menu", {
        path: "/zcat/profile_menu",
        handler: Profile_menu
      });
      this.route("code_block", {
        path: "/zcat/code-block",
        handler: Code_block
      });
      this.route("date-picker", {
        path: "/zcat/date-picker",
        handler: DatePicker
      });
      this.route("time-picker", {
        path: "/zcat/time-picker",
        handler: TimePicker
      });
      this.route("daterangepicker", {
        path: "/zcat/daterangepicker",
        handler: Daterangepicker
      });
      this.route("timerangepicker", {
        path: "/zcat/timerangepicker",
        handler: Timerangepicker
      });
      this.route("sub-header", {
        path: "/zcat/sub-header",
        handler: SubHeader
      });
      this.route("popover", {
        path: "/zcat/popover",
        handler: Popover
      });
      this.route("sidemenu", {
        path: "/zcat/sidemenu",
        handler: Sidemenu
      });
      this.route("fullpage-modal", {
        path: "/zcat/fullpage-modal",
        handler: FullpageModal
      });
      this.route("time-line", {
        path: "/zcat/time-line",
        handler: TimeLine
      });
      this.route("breadcrumb", {
        path: "/zcat/breadcrumb",
        handler: Breadcrumb
      });
      this.route("editor", {
        path: "/lyte/editor",
        handler: Editor
      });
      this.route("icons", {
        path: '/zcat/icons',
        handler: Icons
      });
      this.route("dateselect", {
        path: '/zcat/dateselect',
        handler: Dateselect
      });
      this.route("timezone", {
        path: '/zcat/timezone',
        handler: Timezone
      });
      this.route("doublefield", {
        path: '/zcat/doublefield',
        handler: Doublefield
      });
      this.route("modal-test", {
        path: '/zcat/modal-test',
        handler: ModalTest
      });
      this.route("layout-header", {
        path: '/zcat/layout-header',
        handler: LayoutHeader
      });
    });
  }

  _() {
    _;
  }
}

ZcatComponentsMap.path = '../routes';
export { ZcatComponentsMap };
